var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"row-expanded-body",attrs:{"colspan":"6"}},[_c('h5',[_vm._v("COMMUNICATION LOG")]),_vm._v(" "),_c('span',{staticClass:"block-span"},[_vm._v(_vm._s(_vm.invite.created_at)+" - "),_c('span',{staticClass:"date-span"},[_vm._v("List Added")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }